import { ChangeDetectorRef, Component, Inject, OnDestroy, OnInit } from "@angular/core";
import { BluetoothPrinterService } from "../bluetooth-printer.service";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { Subject, takeUntil } from "rxjs";

@Component({
    selector     : 'md-bluetooth-manager',
    templateUrl  : './md-bluetooth-manager.component.html',
    styleUrls: ['./md-bluetooth-manager.component.scss']
})
export class MdBluetoothManager implements OnInit, OnDestroy {
    loading = false;
    errMessage: string | null = null;
    btDevicesScanned: any[] = [];
    btDeviceConnected: any;
    onComplete = new Subject<void>();

    constructor(
        private btPrinterService : BluetoothPrinterService, 
        private matDialogRef: MatDialogRef<MdBluetoothManager>, 
        private _cdf: ChangeDetectorRef,
        @Inject(MAT_DIALOG_DATA) data: any, 
    ) {
    }

    ngOnInit() {
        this.btPrinterService.bluetoothDevicesScanned.pipe(takeUntil(this.onComplete)).subscribe(devices => {
            this.btDevicesScanned = devices;
            this._cdf.detectChanges();
        });
        this.btPrinterService.scanBTDevices(); 
    }

    ngOnDestroy() {
        this.onComplete.next();
        this.onComplete.complete();
    }

    dismiss() {
        this.matDialogRef.close();
    }

    async doConnectToBTDevice(device: any) {
        this.errMessage = null;
        this.loading = true;
        this._cdf.detectChanges();
        try {
            await this.btPrinterService.connectBTDevice(device.MAC_ADDRESS);
            this.btDeviceConnected = device;
            this.btPrinterService.btPrinterDeviceConnected = device;
            this.loading = false;
        } catch(err: any) {
            this.errMessage = err;
        }
        this._cdf.detectChanges();
    }

    doDisconnectBTDevice() {
        this.btPrinterService.disconnectBTDevice();
        this._cdf.detectChanges();
    }

}